import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import type { Quotation } from '~/api/quotations/types';

import { Icon } from '~/components';
import { statusColorThemes } from '~/styles/themes.css';
import { clsx } from '~/styles/utils';
import { isApprovedOrRejected } from '~/utils/quotations';

import { expiryInfoStyle, expiryInfoTextStyle } from './quotationCell.css';

type Props = {
  quotation: Quotation;
};

export const QuotationDocumentDateCell = ({ quotation }: Props) => {
  const { t } = useTranslation(['quotations']);

  if (!quotation.documentDate) return '–';

  const date = dayjs(quotation.documentDate).format('DD/MM/YYYY');

  const daysUntilExpired = dayjs(quotation.expirationDate).startOf('day').diff(dayjs().startOf('day'), 'day');

  return (
    <div>
      <span>{date}</span>

      {!isApprovedOrRejected(quotation) && (
        <div className={clsx(expiryInfoStyle, daysUntilExpired > 0 ? statusColorThemes['success'] : statusColorThemes['danger'])}>
          <Icon inline name={daysUntilExpired > 0 ? 'HourglassTop' : 'HourglassBottom'} size={16} />

          <span className={expiryInfoTextStyle}>
            {daysUntilExpired > 0
              ? `${daysUntilExpired} ${t('quotations:overview.columns.days')}`
              : dayjs(quotation.expirationDate).format('DD/MM/YYYY')}
          </span>
        </div>
      )}
    </div>
  );
};
